<template>
    <div class="video">
    
    <loadings v-show="videoloading"></loadings>
        <div class="btnlist">
           <button @click="getvideoitme()">获取视频信息</button>
           <button @click="setvideosopt(2)">视频点1</button>
           <button @click="setvideosopt(60)">视频点2</button>
           <button @click="setvideosopt(120)">视频点3</button>
            <div style="background:#f44336;    width: 35px;
    height: 35px;
    position: absolute;
    right: 10vw;
    top: 30vh;" v-if="videosopt < 30">
                <a target="_blank" href="https://my.matterportvr.cn/show/?m=qZaJkwSi5nD&play=1">A</a>
            </div>
            <div style="background: #ffc107;width: 35px;
    height: 35px;
    position: absolute;
    right: 50vw;
    top: 70vh;" v-if="videosopt > 30 && videosopt < 70">
                <a target="_blank" href="https://my.matterportvr.cn/show/?m=qZaJkwSi5nD&play=1">B</a>
            </div>
            <div style="background: #2196f3;width: 35px;
    height: 35px;
    position: absolute;
    left: 30vw;
    top: 30vh;" v-if="videosopt > 70 && videosopt < 120">
                <a target="_blank" href="https://my.matterportvr.cn/show/?m=qZaJkwSi5nD&play=1">C</a>
            </div>
            <div style="background: aqua;width: 35px;
    height: 35px;
    position: absolute;
    left: 10vw;
    top: 80vh;" v-if="videosopt > 120 && videosopt < 220">
                <a target="_blank" href="https://my.matterportvr.cn/show/?m=qZaJkwSi5nD&play=1">D</a>
            </div>
        </div>
        <div class="content" 
        id="videos"
        @mousedown="move" 
        >
            <!-- <video ref="MyVideo" :src="Main.imgserve + '/video/MARKETING.mp4'" class="videodiv" preload="auto">
            </video> -->
        </div>




    </div>
</template>

<script>
import createjs from "preload-js"
import loadings from "../components/loading"
import createjss from "createjs/builds/1.0.0/createjs.js"
export default {
      components:{
        loadings,
    },
    data() {
        return {
            videoele:null,
            videosopt:0,
            //点击起始位置参数
            one_left :null,
            one_top:null,
            videoloading:null,
        }
    },

    watch:{
        videosopt(){

        }
    },

    methods:{
        videoload(){
            this.videoloading = true // 开启加载动画
        if(this.Main.service == './097img'){
                // var url = `${this.Main.imgserve }${value.video}.webm`
        }else{
             var url = this.Main.imgserve + '/video/MARKETING.mp4'
        }

        var mainfest = [  // 等待缓存动画列表
            {src:url,
            type:createjs.AbstractLoader.VIDEO, // 插件自带类型
            id:"MyVideo1"},
        ]
        //动画缓存
        // 使用组件  preload-js 完成动画缓存功能
        var queue = new createjs.LoadQueue(false)
        queue.on("fileload", (e)=>{
          console.log('单个缓存完成--->>>>',e)
        });
        queue.on("complete", (e)=>{
        console.log("整体缓存完成 ！",e)
        this.videoloading = false
        let amtvideo = document.getElementById("videos")
        var videodiv = queue.getResult("MyVideo1")
        console.log(videodiv    )
        videodiv.id = "videodiv"
        videodiv.class="videodiv"
        videodiv.preload = "auto"
        videodiv.playsinline = true
        videodiv.style="width: 100%; height: 100%"
        videodiv.className = "fadein";
        videodiv.muted = false;
        videodiv.play(); 
        amtvideo.appendChild(videodiv) // 追加视频元素
        this.getvideoitme()
        });
        
        queue.setMaxConnections(1); // 每次最大缓存
        queue.loadManifest(mainfest); // 开始缓存

        // this.videotransition = `${this.path}${value.video}.mp4`;
        // let amtvideo = document.getElementById("amtvideo");
        // amtvideo.src = this.videotransition;
        // this.amttype = true;
        // setTimeout(() => {
        //   //设置延迟执行
        //   amtvideo.className = "fadein";
        //   amtvideo.play();
        // }, 500);
        },
    // 鼠标手势处理
    move(e) {
     
      let firstTime = "",
        lastTime = "";
    //   firstTime = new Date().getTime();
      let op = e.target; //获取目标元素
      let width_w = op.offsetWidth; //获取元素宽度
      let height_h = op.offsetHeight; //获取元素高
      document.onmousedown = (e) => {
          // 点击记录起始位置
          this.one_left = e.clientX - op.offsetLeft;
          this.one_top = e.clientY - op.offsetTop;
          //鼠标按下并移动的事件
          //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        //   console.log(left,top, width_w);
        };
      document.onmousemove = (e) => {
        // lastTime = new Date().getTime();
        // if (lastTime - firstTime > 100) {
          //算出鼠标相对元素的位置
          let left = e.clientX - op.offsetLeft;
          let top = e.clientY - op.offsetTop;
          //鼠标按下并移动的事件
          //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
          console.log(Math.abs(left-this.one_left),left,this.one_left);
            if(left-this.one_left > 0 ){
            this.setvideosopt(this.videosopt+=0.1)
            }else{
            this.setvideosopt(this.videosopt-=0.1)
            }
        // firstTime = new Date().getTime();
        // }
      };
      document.onmouseup = (e) => {
        document.onmousemove = null;
        document.onmouseup = null;
        this.one_left = null
        this.one_top = null
        // this.positionY_1 = 0;
      };
      document.onmousewheel = (e) => {
        // 鼠标滚轮事件
        // let op = document.getElementsByClassName("model_content")[0]; //获取操作元素
        var eleW = op.offsetWidth;
        var eleH = op.offsetHeight;
        console.log("鼠标缩放操作===>>>", this.fangm);

        // if (e.wheelDelta < 0) {
        //   console.log("-");
        //   this.fangm > 0.3 ? (this.fangm -= 0.1) : 0.3;
        //   op.style.transform = "scale(" + this.fangm + ")";
        // } else {
        //   console.log("+");
        //   this.fangm < 2 ? (this.fangm += 0.1) : 2;
        //   op.style.transform = "scale(" + this.fangm + ")";
        // }
      };
    },

        getvideoitme(itme){
            this.videoele = document.getElementById("videodiv")
            this.videosopt = this.videoele.currentTime
            this.videoele.addEventListener('timeupdate',() =>{
                this.videosopt = this.videoele.currentTime
                // console.log('设置、获取当前播放时间：',this.videoele.currentTime)
            })

            console.log('设置、获取当前播放时间：',this.videoele.currentTime)
            console.log('当前视频默认播放速度：',this.videoele.defaultPlaybackRate)
            console.log('设置视频播放速度：',this.videoele.playbackRate)
            console.log('视频长度s：',this.videoele.duration )
            var duration = this.videoele.duration;
            var hour = parseInt(duration / 3600);
            var minute = parseInt(duration % 3600 / 60);
            var sec = parseInt(duration);
            console.log("视频长度为：" + duration + ",   " + hour + ":" + minute + ":" + sec);

        },
        
        setvideolong(long){

        },
        setvideosopt(sopt){
            console.log(sopt)
            this.videoele = document.getElementById("videodiv")
            this.videoele.currentTime = sopt
        },
    },
    mounted(){
        this.videoload()
}
}
</script>

<style lang="less">
    
.video{
    width: 95%;
    height: 95%;
    margin: auto;
    padding: 0;
    user-select: none;
    overflow: hidden;
    .btnlist{
        width: 100%;
        // height: 19%;
        position: absolute;
        z-index: 999;
    }
    .content{
        width: 100%;
        height: 100%;
        .videodiv{
            width: 100%;
            // height: 100%;
        }
    }




}


</style>









